import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import RadioGroup from '../../../reusable/Form/RadioGroup.jsx';
import SelectEntitiesFilter from './../../../reusable/Dropdowns/SelectEntities.filter'

class EntitiesFilter extends React.PureComponent {

    static propTypes = {
        entities: PropTypes.object,
        changeHandlers: PropTypes.object,
        categories: PropTypes.object,
        entitiesSelection: PropTypes.object,
        filtersState: PropTypes.string
    }

    static defaultProps = {
        entitiesSelection: null
    }

    onChange(e) {
        return null;
    }

    render() {
        const options = [
            {
                value: 'all_entities',
                label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectAll"/>
            },
            {
                value: 'specific',
                label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectBySpecific"/>,
                content: <SelectEntitiesFilter switchEntity={() => {}}
                                               entities={this.props.entities}
                                               selectedEntities={this.props.entitiesSelection.entitiesId} />
            },
            {
                value: 'categories',
                label: <FormattedMessage id="RSS_Add_UIText_addRssFeed.thirdParties.selectByCategory"/>,
                content: null
            }
        ]
        return <div className={'disabled-entities-filter'}>
            <div className={"shield"} />
            <RadioGroup value={this.props.entitiesSelection.type} onChange={this.onChange} fieldId={"entities-filter"} options={options} classNames="notranslate"/>
        </div>
    }

}

export default injectIntl(EntitiesFilter);


// WEBPACK FOOTER //
// ./src/scripts/pages/EntityDashboard/components/DisabledEntities.filter.jsx